import {
  Sofa, Refrigerator, Warehouse, Boxes, Home, HandHeart, Building2, Package,
  TreePine, Hammer, Briefcase, Truck, Recycle, Ruler, Sparkles, Bone,
  Smile, Tag, PawPrint, CheckCircle2, ShieldCheck,
} from "lucide-react";

export const iconMap = {
  Sofa, Refrigerator, Warehouse, Boxes, Home, HandHeart, Building2, Package,
  TreePine, Hammer, Briefcase, Truck, Recycle, Ruler, Sparkles, Bone,
  Smile, Tag, PawPrint, check: CheckCircle2, paw: PawPrint, ShieldCheck,
};

export const Icon = ({ name, className, strokeWidth = 1.75 }) => {
  const Cmp = iconMap[name] || CheckCircle2;
  return <Cmp className={className} strokeWidth={strokeWidth} />;
};
